import React, { useEffect, useState } from "react"
import { Modal, Button, Input, message, Radio } from "antd"
import { orderPrintInfo, printNum, getOrderOne } from "@/service/ordersService"
import "./orderPrint.css"
import { getUserInfo, getPcodeDict } from "@/utils/dataStorage"
import { numberParseChina } from "@/utils/util"
import moment from "moment"
import {SettleScaniaPrint} from "../../../../erp_subpackage/components/SettleScaniaPrint"
import { prebookService } from "../prebookService";
import { useDictModel } from "@/erp_subpackage/pages/base/dict/dictModel"
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum"

const SettleScaniaPrints = (props) => {
    const { visible, onClose } = props
    // const [protList, setProtList] = useState([])
    // const [protListSB, setProtListSB] = useState([])
    // const [protListSF, setProtListSF] = useState([])
    // const [itemListSB, setItemListSB] = useState([])
    // const [itemListSF, setItemListSF] = useState([])
    const [otherList, setOtherList] = useState([])
    const [baseInfo, setBaseInfo] = useState({})
    const [dictObj, setDictObj] = useState({ serviceType: {}, orderSource: {}, orderTypes: {} })
    // const [setVisible, setSetVisible] = useState(false)
    // const [orderType, setOrderType] = useState("")
    const [serviceNature, setServiceNature] = useState("")
    const [titles, setTieles] = useState("")
    const [price, setPrice] = useState({})
    // const [orderCode, setOrderCode] = useState('')
    // const [payType, setPayType] = useState("");//结算方
    const [formVal, setFormVal] = useState({});
    const [maintenanceList, setMaintenanceList] = useState([]);
    const [itemList, setItemList] = useState([]);
    const { getSelectedDictOne } = useDictModel(() => []);
    useEffect(() => {
        initDict()
    }, [])
    useEffect(() => {
        if(dictObj.threeGuaranteesUnit){
        loadData()
    }
    }, [dictObj])
    const loadData = () => {
        prebookService.printInfo(visible.orderId).then((res) => {
            setFormVal({...res.retData,
                customerName:res.retData.customerName,
                licensePlate:res.retData.vehicleCode,
                vin:res.retData.vehicleVin,
                contact:res.retData.senderRepairUserName,
                phone:res.retData.senderRepairUserPhone,
                serviceTypeName:dictObj.serviceType[res.retData.serviceType],
                vehicleTypeName:res.retData.vehicleType,
                customerAddress:res.retData.repairAddress,
                maintenanceCode:res.retData.prebookCode,
                enterTime:res.retData.entryFactoryTime,
                deliveryTime:res.retData.outFactoryTime,
                createUserName:res.retData.createUser,
                mileage:res.retData.mileage,
                faultDesc:res.retData.faultDesc,
                payType:res.retData.settlementType,
                settlementPartyName:res.retData.settlementPartyCode?getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY).find(item =>res.retData.settlementPartyCode==item.value).label:""
            })
            const { entityName, orderType: orderTypes } = res.retData
            if (orderTypes && orderTypes === "014001") {
                //收费
                setServiceNature("016002")
            } else if (orderTypes && orderTypes === "014002") {
                // 三包
                setServiceNature("016001")
            }else if (orderTypes && orderTypes === "014006") {
                // 云豪三包
                setServiceNature("016004")
            }
            setTieles(entityName)
            // 016001 三包
            // 016002 收费
            setMaintenanceList(res.retData.materials)
            setItemList(res.retData.items)

            let preferentialAmount = 0;
            let receivableAmount = 0;
            let itemAmount = 0;
            res.retData.items.forEach(e => {
                itemAmount = (Number(itemAmount) + Number(e.actualAmount)).toFixed(2);
                preferentialAmount = (Number(preferentialAmount) + Number(e.preferentialAmount)).toFixed(2);
                receivableAmount = (Number(receivableAmount) + Number(e.actualAmount)).toFixed(2);
            });
            let materialAmount = 0;
            res.retData.materials.forEach(e => {
                materialAmount = (Number(materialAmount) + Number(e.actualAmount)).toFixed(2);
                preferentialAmount = (Number(preferentialAmount) + Number(e.preferentialAmount)).toFixed(2);
                receivableAmount = (Number(receivableAmount) + Number(e.actualAmount)).toFixed(2);
            });
            setPrice({
                workingHoursAmount:itemAmount,
                materialScienceAmount:materialAmount,
                orderTotalAmount:(Number(itemAmount) + Number(materialAmount)).toFixed(2),
                orderPreferentialAmount:preferentialAmount,
                totalAmount:receivableAmount,
            })
        })
    }

    //初始下订单用到的字典
    const initDict = () => {
        let obj = {
            serviceType: {}, //服务类型
            orderSource: {}, //支付方式
            orderTypes: {},
            threeGuaranteesUnit: {},
        }
        getPcodeDict("011").children.forEach((item) => {
            obj.serviceType[item.dictCode] = item.title
        })
        getPcodeDict("018").children.forEach((item) => {
            obj.orderSource[item.dictCode] = item.title
        })
        getPcodeDict("014").children.forEach((item) => {
            obj.orderTypes[item.dictCode] = item.title
        })
        getPcodeDict("106").children.forEach((item) => {
            obj.threeGuaranteesUnit[item.dictCode] = item.title
        })

        setDictObj(obj)
    }
    const itemClumns = [
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '项目编号',
            dataIndex: 'itemCode',
        },
        {
            title: '项目名称',
            dataIndex: 'itemName',
        },
        {
            title: '工时',
            dataIndex: 'itemWorkHours',
        },
        {
            title: '单价',
            dataIndex: 'workHoursPrice',
        },
        {
            title: '优惠',
            dataIndex: 'preferentialAmount',
        },
        {
            title: '折扣',
            dataIndex: 'itemDiscount',
        },
        {
            title: '总金额',
            dataIndex: 'actualAmount',
        },
        {
            title: '备注',
            dataIndex: 'remark',
            colSpan:2
        },
    ]
    const columns =[
        {
            title: '序号',
            dataIndex: 'No',
        },
        {
            title: '商品编号',
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            dataIndex: 'materialName',
        },
        {
            title: '数量',
            dataIndex: 'materialNumber',
        },
        {
            title: '单价',
            dataIndex: 'salePrice',
        },
        {
            title: '优惠',
            dataIndex: 'preferentialAmount',
        },
        {
            title: '折扣',
            dataIndex: 'materialDiscount',
        },
        {
            title: '总金额',
            dataIndex: 'actualAmount',
        },
        {
            title: '备注',
            dataIndex: 'remark',
        },
    ]
    const otherClumns = [
            {
                title: '序号',
                dataIndex: 'No',
            },
            {
                title: '项目编码',
                dataIndex: 'itemCode',
            },
            {
                title: '项目名称',
                dataIndex: 'itemName',
            },
            {
                title: '数量',
                dataIndex: 'itemNumber',
            },
            {
                title: '单价',
                dataIndex: 'unitPrice',
            },
            {
                title: '金额',
                dataIndex: 'itemAmount',
            },
            {
                title: '备注',
                dataIndex: 'remark',
                colSpan:2
            },
        ]
    //转换number，保留两个0
    const switchNum = (num, n = 2) => {
        return Number(num).toFixed(n)
    }
    return (
        <SettleScaniaPrint
        title={titles}
        visible={visible}
        onClose={onClose}
        columns={columns}
        itemClumns={itemClumns}
        otherClumns={otherClumns}
        itemDataSource={itemList}
        dataSource={maintenanceList.filter(item => item.num !== 0)}
        otherDataSource={otherList}
        formVal={formVal}
        isTechnician={true}
        baseInfo={baseInfo}
        price={price}
        // printNum={visible.printNum}
        onPrint={() => prebookService.recordPrint(visible.orderId)}
    />
    )
}

export default SettleScaniaPrints
